module.exports = __webpack_public_path__ + "img/east-logo-bug.2add246d.png";